import { defineMessages } from 'react-intl-next';

export const messages: {
	clearIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description: 'Label text for clear search button',
	},
	inputPlaceholder: {
		id: 'input_placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text in primary search input',
	},
	inputAriaLabel: {
		id: 'input_aria_label',
		defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
		description: 'Aria label for primary search input, directs users advanced search',
	},
});
